"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HtmlPanel = void 0;
const IHomePanelWidget_1 = require("../../core/pluginSystem/IHomePanelWidget");
class HtmlPanel {
    constructor(basePlugin) {
        this.basePlugin = basePlugin;
        this.widgetSize = IHomePanelWidget_1.WidgetSize.Fill;
    }
    get widgetId() {
        return "htmlWidget";
    }
    get panelName() {
        return "HTML";
    }
    get panelId() {
        return "HTML";
    }
    renderContent(content, metadata) {
        return __awaiter(this, void 0, void 0, function* () {
            let html = metadata.value["html"];
            content.element.innerHTML = html;
        });
    }
    renderWidget(widgetContainer, pluginMetadata) {
        return __awaiter(this, void 0, void 0, function* () {
            let html = pluginMetadata.value["html"];
            widgetContainer.element.innerHTML = html;
        });
    }
}
exports.HtmlPanel = HtmlPanel;
//# sourceMappingURL=HtmlPanel.js.map